module.exports = __webpack_public_path__ + "static/media/14UNEP25.78540057.jpg";